<template>
	<div class="load-file-input-container" :style="`height:${height}px`">
		<input
			v-if="showInput"
			disabled
			class="load-input"
			:style="`border-color:${$appColors.gray}`"
			v-bind="$attrs"
			:value="value"
		/>
		<input
			hidden 
			type="file"
			ref="load"
			:accept="allowedFileExtensions"
			@change="getFile"
		/>
		<app-button
			icon-after
			:class="[ classBtn || 'load-btn']"
			:disabled="disabled"
			:icon="icon"
			:icon-color="color"
			:style="`background-color:${$appColors.success}`"
			@click="loadFile"
		/>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function loadFile() {
	this.$refs.load.click();
}

function getFile(e) {
	const [file] = e.target.files;
	const [fileName, fileExt] = file.name.split('.');
	let fileReName = fileName;
	fileReName = this.nameFile;
	const reader = new FileReader();
	reader.onload = async (f) => {
		const fileData = {
			name: fileReName.replace(/\s/g, ''),
			base64data: f.target.result,
			type: fileExt,
			codeCompany: this.code,
		};
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		try {
			if (fileExt === 'jpeg') {
				const { data: response } = await this.$httpPraktiko.post(
					'external-api/upload-file-applicant', fileData, { headers });
				this.$emit('input', response);
				this.$store.dispatch(
					'showSnackBar', { text: `Archivo: "${fileReName}" cargado`, color: 'success' });
			} else {
				throw Error('ERROR_EXTENSION');
			}
		} catch (error) {
			if (error.message === 'ERROR_EXTENSION') {
				this.showNotification('Se requiere imagen en formato .jpeg', 'warning');
			} else {
				let text = '';
				if (error.status === 500) {
					text = 'Error del servidor';
				}
				this.$store.dispatch('showSnackBar', { text, color: 'error' });
			}
		}
	};
	reader.readAsDataURL(file);
}

export default {
	name: 'load-file-input',
	components: {
		appButton,
	},
	inheritAttrs: false,
	methods: {
		getFile,
		loadFile,
	},
	props: {
		allowedFileExtensions: {
			default: '.jpeg',
			type: String,
		},
		height: {
			default: 32,
			type: Number,
		},
		showInput: {
			type: Boolean,
			default: true,
		},
		nameFile: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'attach_file',
		},
		color: {
			type: String,
			default: 'white',
		},
		classBtn: {
			type: String,
			default: '',
		},
		value: null,
		code: {
			type: String,
			default: '',
		},
	},
};
</script>
<style lang="scss" scoped>
.load-file-input-container {
	align-items: center;
	display: flex;
	justify-content: flex-start;

	.load-input {
		background-color: white;
		border-bottom: 1px solid;
		border-top: 1px solid;
		border-left: 1px solid;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		flex-basis: 90%;
		height: 100%;
		padding-left: 20px;
	}

	.load-input::placeholder {
		color: color(gray-medium);
	}

	.load-btn {
		height: 100%;
		flex-basis: 12%;
	}

	.circle-btn {
		background: color(white);
		border-radius: 50%;
		padding: 6px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/load-image.vue